<template>
  <VFileUpload v-model="filesToUpload" clearable multiple show-size :rules="[fileSizeRule]" :disabled="isLoading">
    <template v-slot:item="{ props: itemProps }">
      <VFileUploadItem v-bind="itemProps" lines="one" nav>
        <template v-slot:prepend>
          <VAvatar size="32" rounded></VAvatar>
        </template>

        <template v-slot:clear="{ props: clearProps }">
          <VBtn color="primary" v-bind="clearProps"></VBtn>
        </template>
      </VFileUploadItem>
    </template>
  </VFileUpload>
  <div class="d-flex flex-column align-center justify-center py-4 w-100">
    <VBtn color="primary" class="mt-3" @click="uploadFiles()" :loading="isLoading"> Upload Files </VBtn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// Services
import documentsService from '@/services/documents-service/documents.service';
// Components
import { VFileUpload } from 'vuetify/lib/labs/VFileUpload';
import { VFileUploadItem } from 'vuetify/lib/labs/VFileUpload';
// Utils
import { fileToBase64 } from '@/utils/convertBlobToBase64';
import { formatDocument } from '@/utils/formatData';
export default {
  name: 'UploadDocuments',
  components: {
    VFileUpload,
    VFileUploadItem
  },

  props: {
    recordId: {
      type: String
    }
  },

  emits: ['success'],

  data() {
    return {
      isLoading: false,
      filesToUpload: [],
      fileSizeRule: (files) => {
        if (!files || files.length === 0) return true;

        const maxSize = 5 * 1024 * 1024;

        for (const f of files) {
          if (f.size > maxSize) {
            return `File "${f.name}" exceeds 5 MB limit`;
          }
        }

        return true;
      }
    };
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    // Files
    async uploadFiles() {
      const files = this.filesToUpload;
      if (!files || files.length === 0) {
        this.showSnackbar({ text: 'No files selected', color: 'red' });
        return;
      }

      this.isLoading = true;
      try {
        const uploadedFiles = [];
        for (const file of files) {
          const { base64, fileType, fileSize } = await fileToBase64(file);

          const payload = {
            recordId: this.recordId,
            fileName: file.name,
            fileType: fileType,
            fileSize: fileSize,
            base64: base64
          };

          const { document } = await documentsService.uploadDocumentToRequest(payload);

          if (document?.documentId) {
            uploadedFiles.push(formatDocument(document));
          }
        }
        this.filesToUpload = [];
        this.showSnackbar({ text: 'Files uploaded successfully', color: 'green' });
        console.log('Uploaded files:', uploadedFiles);
        this.$emit('success', this.recordId);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err.message || 'Failed to upload files', color: 'red' });
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
